import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdClass, MdDone, MdEmail, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";

function SentRequestStatusStudent() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    let name = "Roy";

    const [studentEmail, setStudentEmail] = useState('')

    const [error, setError] = useState({
        invalidEmail: false,
        noEmail: false
    })


    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [approveRequests, setApproveRequests] = useState([
        {
            receiverEmail: "",
            userRole: "",
            senderEmail: "",
            sentTime: "",
            invitationStatus: "PENDING",
            id: ""
        }
    ])

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
            // console.log("1");

        } else if (err.toLowerCase().includes('found')) {
            setErrorMsg(t('t258'));
            // console.log("2");
        } else if (err.toLowerCase().includes('already sent')) {
            setErrorMsg(t('t259'));
            // console.log("2");
        } else {
            setErrorMsg(t('t94'));
            // console.log("3");
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (logDetails) {

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(`${web_url}/api/invitations/admin`, configToken).then((response) => {
                const filteredRequest2 = response.data.filter(request => request.userRole === "STUDENT");
                const filteredDataInv = filteredRequest2.map(invitation => ({
                    ...invitation,
                    sentTime: formatDate(invitation.sentAt),
                }))
                setApproveRequests(filteredDataInv)
                // setApproveRequests(filteredRequest2)
                setIsLoading(false);
            }).catch((errInv) => {
                setIsLoading(false);
                if (errInv.response) {
                    // console.log(err.response)
                    if (errInv.response.data.error) {
                        handleClickOpenError(errInv.response.data.error);
                    } else if (errInv.response.data.message) {
                        handleClickOpenError(errInv.response.data.message);
                    } if (errInv.response.data.token) {
                        handleClickOpenError(errInv.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
            })
        }


    }, [localStorage.getItem('refresh')])

    const handleResent = (emailUser, role, id) => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();

        const resendDetails = {
            senderEmail: logDetails.email,
            receiverEmail: emailUser,
            userRole: role.toUpperCase()
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.post(`${web_url}/api/invitations/admin`, resendDetails, config).then((response) => {
            axios.delete(`${web_url}/api/invitations/admin/${id}`, configToken).then((delRes) => {
                // const filteredRequest = approveRequests.filter(request => request.id !== id);
                // setApproveRequests(filteredRequest)
                localStorage.setItem("refresh", "refresh")
                setIsLoading(false);
            }).catch((delErr) => {
                setIsLoading(false);
                if (delErr.response) {
                    // console.log(err.response)
                    if (delErr.response.data.error) {
                        handleClickOpenError(delErr.response.data.error);
                    } else if (delErr.response.data.message) {
                        handleClickOpenError(delErr.response.data.message);
                    } if (delErr.response.data.token) {
                        handleClickOpenError(delErr.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
            })
        }).catch((errInv) => {
            setIsLoading(false);
            if (errInv.response) {
                // console.log(err.response)
                if (errInv.response.data.error) {
                    handleClickOpenError(errInv.response.data.error);
                } else if (errInv.response.data.message) {
                    handleClickOpenError(errInv.response.data.message);
                } if (errInv.response.data.token) {
                    handleClickOpenError(errInv.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
        })

    }

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden min-h-screen w-screen xl:pt-[20px]`}>

                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/researcher/resend/invitation/select')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/researcher/resend/invitation/select')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/researcher/resend/invitation/select')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t261')} - {t('t186')}</p>
                    </div>
                </div>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="mt-[10px] md:mt-[20px] xl:hidden pb-[100px]">
                                {
                                    approveRequests.map((request, index) => (
                                        <div className="mt-[10px] md:mt-[15px] flex items-center justify-between px-[20px] ml-[20px] mr-[10px] md:ml-[100px] md:mr-[100px] lg:ml-[140px] lg:mr-[140px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                            <div className="md:hidden flex flex-col">

                                                <p className="text-[#8189B0] text-[12px] ">{request.receiverEmail.length > 28
                                                    ? `${request.receiverEmail.slice(0, 28)}...`
                                                    : request.receiverEmail}</p>
                                                <p className="text-[#8189B0] text-[12px] ">{request.userRole.length > 30
                                                    ? `${request.userRole.slice(0, 30)}...`
                                                    : request.userRole}</p>
                                                <p className="text-[#8189B0] text-[12px]  ">{request.sentTime}</p>
                                                <p className="text-[#8189B0] text-[12px] pt-[5px]">{t("t434")}: {request.senderEmail.length > 28
                                                    ? `${request.senderEmail.slice(0, 28)}...`
                                                    : request.senderEmail}</p>
                                            </div>
                                            <div className="hidden md:flex flex-col">

                                                <p className="text-[#8189B0] text-[15px] ">{request.receiverEmail.length > 35
                                                    ? `${request.receiverEmail.slice(0, 45)}...`
                                                    : request.receiverEmail}</p>
                                                <p className="text-[#8189B0] text-[15px] ">{request.userRole.length > 35
                                                    ? `${request.userRole.slice(0, 45)}...`
                                                    : request.userRole}</p>
                                                <p className="text-[#8189B0] text-[15px] ">{request.sentTime}</p>
                                                <p className="text-[#8189B0] text-[15px] pt-[5px]">{t("t434")}: {request.senderEmail.length > 35
                                                    ? `${request.senderEmail.slice(0, 45)}...`
                                                    : request.senderEmail}</p>
                                            </div>
                                            <div className="flex flex-col">
                                                <button className={`${request.invitationStatus === "PENDING" ? 'text-red-600' : 'text-black font-bold'}  text-[13px] rounded-lg py-[3px] w-[100px]`}>{request.invitationStatus}</button>
                                                {
                                                    request.invitationStatus === "PENDING" &&
                                                    <button onClick={() => {
                                                        handleResent(request.receiverEmail, request.userRole, request.id)
                                                    }} className="mt-[5px] bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t262')}</button>

                                                }
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>

                            <div className="mt-[10px] hidden xl:grid grid-cols-3 pb-[50px] ml-[80px] mr-[70px]">
                                {
                                    approveRequests.map((request, index) => (
                                        <div key={index} className="mt-[10px] flex items-center justify-between px-[20px] ml-[10px] mr-[5px] bg-[#F1F6FB] py-[10px] rounded-lg">
                                            <div className="2xl:hidden flex flex-col">
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.receiverEmail.length > 40
                                                    ? `${request.receiverEmail.slice(0, 40)}...`
                                                    : request.receiverEmail}</p>
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.userRole.length > 40
                                                    ? `${request.userRole.slice(0, 40)}...`
                                                    : request.userRole}</p>
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.sentTime}</p>
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] pt-[5px]">{t("t434")}: {request.senderEmail.length > 40
                                                    ? `${request.senderEmail.slice(0, 40)}...`
                                                    : request.senderEmail}</p>
                                            </div>
                                            <div className="hidden 2xl:flex flex-col">
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.receiverEmail.length > 45
                                                    ? `${request.receiverEmail.slice(0, 45)}...`
                                                    : request.receiverEmail}</p>

                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.userRole.length > 45
                                                    ? `${request.userRole.slice(0, 45)}...`
                                                    : request.userRole}</p>
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] ">{request.sentTime}</p>
                                                <p className="text-[#8189B0] text-[11px] 2xl:text-[13px] pt-[5px]">{t("t434")}: {request.senderEmail.length > 45
                                                    ? `${request.senderEmail.slice(0, 45)}...`
                                                    : request.senderEmail}</p>
                                            </div>
                                            <div className="flex flex-col">
                                                <button className={`${request.invitationStatus === "PENDING" ? 'text-red-600' : 'text-black'}  text-[13px] rounded-lg py-[3px] w-[100px]`}>{request.invitationStatus}</button>
                                                {
                                                    request.invitationStatus === "PENDING" &&
                                                    <button
                                                        onClick={() => {
                                                            handleResent(request.receiverEmail, request.userRole, request.id)
                                                        }}
                                                        className="mt-[5px] bg-[#BBFFA3] text-black text-[13px] rounded-lg py-[3px] w-[100px]">{t('t262')}</button>

                                                }
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>

                        </>
                }
            </div>
            <Dialog
                open={open2}
                onClose={handleClose}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>{t('t263')}</div>
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t213')}
                                </Button>
                            </div>
                        </DialogContent>
                    }

                    {
                        isLoading &&
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <Commet color="#FDC50C" size="medium" text="" textColor="" />
                        </DialogContentText>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2 ">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SentRequestStatusStudent;
